module.exports = __webpack_public_path__ + "img/CNN.417d5fbd.png";